<ng-container *ngIf="vehiclesForm" [formGroup]="vehiclesForm">
  <div class="toggle-wrapper select-all">
    <div>
      <strong class="semi-bold"> Tents Only </strong>
    </div>
    <curbnturf-toggle [selected]="tentOnly()" (clicked)="selectNone()" class="select-only-tent"> </curbnturf-toggle>
    <div class="flex-grow">&nbsp;</div>
    <div>
      <strong class="semi-bold"> Select All </strong>
    </div>
    <curbnturf-toggle [selected]="allSelected()" (clicked)="selectAll()" class="select-all-rvs"> </curbnturf-toggle>
  </div>
  <div class="_18-px"></div>
  <div class="button-wrapper-grid listing">
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-class-a" formControlName="classA" />
      <label for="vehicles-class-a">
        <div [style.opacity]="selected('classA') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line type="classA" [opacity]="1" [secondary]="true"> </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Class A</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('classA')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-class-b" formControlName="classB" />
      <label for="vehicles-class-b">
        <div [style.opacity]="selected('classB') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line type="classB" [opacity]="1" [secondary]="true"> </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Class B</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('classB')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-class-c" formControlName="classC" />
      <label for="vehicles-class-c">
        <div [style.opacity]="selected('classC') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line type="classC" [opacity]="1" [secondary]="true"> </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Class C</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('classC')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-fifth-wheel" formControlName="fifthWheel" />
      <label for="vehicles-fifth-wheel">
        <div [style.opacity]="selected('fifthWheel') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line type="fifthWheel" [opacity]="1" [secondary]="true">
            </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Fifth Wheel</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('fifthWheel')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-trailer" formControlName="travelTrailer" />
      <label for="vehicles-trailer">
        <div [style.opacity]="selected('travelTrailer') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line type="travelTrailer" [opacity]="1" [secondary]="true">
            </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Travel Trailer</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('travelTrailer')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-truck" formControlName="truckCamper" />
      <label for="vehicles-truck">
        <div [style.opacity]="selected('truckCamper') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line type="truckCamper" [opacity]="1" [secondary]="true">
            </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Truck Camper</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('truckCamper')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-teardrop" formControlName="teardrop" />
      <label for="vehicles-teardrop">
        <div [style.opacity]="selected('teardrop') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line type="teardrop" [opacity]="1" [secondary]="true"> </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Teardrop</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('teardrop')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
    <div class="rv-button" style="opacity: 1">
      <input type="checkbox" id="vehicles-popup" formControlName="popup" />
      <label for="vehicles-popup">
        <div [style.opacity]="selected('popup') ? 1 : 0.15" class="rv-button-container">
          <div class="rv-button-icon">
            <curbnturf-trailer-svg-line
              [type]="selected('popup') ? 'popupActive' : 'popup'"
              [opacity]="1"
              [secondary]="true"
            >
            </curbnturf-trailer-svg-line>
          </div>
          <div class="rv-button-copy">Popup Trailer</div>
        </div>
        <curbnturf-misc-svg
          *ngIf="!selected('popup')"
          icon="slash"
          color="#f00b"
          style="height: 120px; width: 120px; position: absolute; top: 0; left: 0; right: 0; margin: auto"
        >
        </curbnturf-misc-svg>
      </label>
    </div>
  </div>
</ng-container>
